import script from "./ChatPublishReportModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPublishReportModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatPublishReportModal.vue?vue&type=style&index=0&id=127fd48c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-127fd48c"]])

export default __exports__